import { VariableRowType } from '@pages/Variables/types'

import { useExecuteCommandMutation } from '@redux/api'

import { executeCommandAction, useOpenForm } from '@hooks'
import { ENTITY, FORM_TYPE } from '@constants'
import { ActionRow, ObjectDataRecord } from '@types'

type HandleOpenFormActionProps = {
  action: ActionRow
  openForm: ReturnType<typeof useOpenForm>['openForm']
  executeCommand?: ReturnType<typeof useExecuteCommandMutation>[0]
  dialogId?: string | null
  context: ObjectDataRecord
  formVariables: VariableRowType[]
}

export const handleOpenFormAction = (props: HandleOpenFormActionProps) => {
  const { action, openForm, executeCommand, dialogId, context, formVariables } = props

  const openIndependentForm = () => {
    if (openForm) {
      openForm(action, {
        formProps: {
          formCode: action.objectFormCode || '',
          event: FORM_TYPE.CREATE,
          viewCode: '',
          title: '',
          id: '',
          objectCode: (action.objectCode as string) ?? '',
          path: '',
          entityType: ENTITY.VIEW,
          isIndependentForm: true,
          variables: formVariables,
        },
        parentDialogId: dialogId ?? null,
        additionalProps: {
          addHistory: true,
        },
      })
    }
  }

  if (!action.command || !executeCommand) {
    openIndependentForm()

    return
  }

  executeCommandAction({
    action,
    executeCommand,
    context,
  }).then(() => {
    openIndependentForm()
  })
}
